import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { message, Modal } from 'antd';

import logo from './imgs/logo.svg';
import './FeaturedStores.css'

class FeaturedStores extends Component {

  state = {
    featuredStores: [],
    username: '',
    offerData: {},
    visible: false,
  };

  componentWillReceiveProps(thisProps) {
    this.setState({
      featuredStores: thisProps.data.featuredStores,
        username: thisProps.username,
    })
  }

  handleClick(item) {
    if (this.state.username === null || this.state.username.length !== 40) {
      message.error('Please login to active your cashback.');
    }
    this.setState({
      offerData: {
          storeUrl: item.storeUrl,
          logoUrl: item.logoUrl,
          offerRate: item.offerRate,
          offerDetails: item.offerDetails,
      },
      visible: true,
    });
  }

  handleOk = () => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };

  handleOpen = () => {
    this.handleCancel();
    window.open(this.state.offerData.storeUrl);
  };

  render() {
    return (
      <div className="FeaturedStores">
        <div className='List'>
          {this.state.featuredStores !== undefined && this.state.featuredStores.map((item, index) => {
            return (
              <div key={index} className='Card' onClick={() => this.handleClick(item)}>
                <img src={item.logoUrl} alt={item.storeName} />
                <p>{item.storeName}</p>
              </div>
            )
          })}
        </div>
        <Modal
          onOk={this.handleOk}
          visible={this.state.visible}
          onCancel={this.handleCancel}
          wrapClassName="vertical-center-modal"
          className='storesModal'
        >
          <div className="modal-header">
            <img src={this.state.offerData.logoUrl} alt='logo' className='logo'/>
            <div>
              <img src={logo} alt="qbates"/>
              <h3>Cashback up to {this.state.offerData.offerRate}</h3>
            </div>
          </div>
          <div className="modal-body">
            {this.state.offerData.offerDetails !== undefined && this.state.offerData.offerDetails.map((data, index) => {
              return (
                <div key={index} className='listItem'>
                  <span className='goods'>{data.split(':')[0]}</span>
                  <span className='rate'>{data.split(':')[1]} cashback</span>
                </div>
              )
            })}
          </div>
          <div className='button'>
            <button onClick={() => {this.state.username !== '' && this.state.username !== null ? this.handleOpen() : this.props.history.push('/login')}}>Activate Cashback up to {this.state.offerData.offerRate}</button>
            <button id="mobile" onClick={() => {this.state.username !== '' && this.state.username !== null ? this.handleOpen() : this.props.history.push('/login')}}>Activate Now!</button>
          </div>
        </Modal>
      </div>
    );
  }
}

export default withRouter(FeaturedStores);


// WEBPACK FOOTER //
// ./src/Containers/Stores/components/FeaturedStores.js